import { useEffect } from "react";
import { Container, Image } from "react-bootstrap";
import {
    AboutSection,
    AboutText,
    AboutTitle,
    AboutSmallText,
    AboutList,
    AboutItem,
    NeedSection,
    NeedTitle,
    FounderNeed,
    FounderImage,
    FounderText,
    FounderSmallText,
    FounderDesignation,
    OpportunitySection,
} from './elliottAdvocacyStyle';
import Founder from "../../../assests/images/founder_image.webp";
import { MESSAGE } from "../../../utils/message";
import { useDispatch, useSelector } from "react-redux";
import { elliottAdvocacyHandler } from "../../../redux/slices/elliottAdvocacy/elliott-advocacy";
import { AdvocacyTitle, ElliottAdvocacyBanner } from "../../../components/common/commonSubPageBanner/commonSubPageBannerStyle";
import MetaComponent from "../../../components/common/metaComponent";

const ElliottAdvocacy = () => {
   const dispatch:any = useDispatch();
   const PersonInfo = useSelector((state:any) => state?.elliottAdvocacy?.data)

   useEffect(() => {
      dispatch(elliottAdvocacyHandler())
   }, [])

    return (
      <>
      <MetaComponent 
            keywords=""
            description=""
            ogTitle="Success Story: Elliott Advocacy | GreatNonprofits"
            ogDescription=""
            ogUrl="https://www.about.greatnonprofits.org/elliott-advocacy"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
      
      <> 
       {/* <SubPageBanner/> */}
       <ElliottAdvocacyBanner className="elliott-advocacy-banner">
           <Container className="cont-w">
               <AdvocacyTitle className='title-sub-page'> {MESSAGE.elliottAdvocacyHelp}</AdvocacyTitle>
            </Container>
        </ElliottAdvocacyBanner>

         <AboutSection>
            <Container className="cont-w"> 
               <AboutText>
                   <AboutTitle>{MESSAGE.about}</AboutTitle>
                   <AboutSmallText>{MESSAGE.elliottAdvocacyDesc}</AboutSmallText>
                     <AboutList>
                        <AboutItem>
                         {MESSAGE.elliottAdvocacyMsg1}
                        </AboutItem>
                        
                        <AboutItem>
                        {MESSAGE.elliottAdvocacyMsg2}
                        </AboutItem>

                        <AboutItem>
                        {MESSAGE.elliottAdvocacyMsg3}

                        </AboutItem>
                     </AboutList>
                     <AboutSmallText>{MESSAGE.elliottAdvocacyMsg4}</AboutSmallText>
               </AboutText>
               <NeedSection>
                  <NeedTitle>{MESSAGE.theNeedTitle}</NeedTitle>
                  <AboutSmallText>{MESSAGE.theNeed}</AboutSmallText>
                  <FounderNeed>
                     <FounderImage>
                        <Image src={Founder} alt="Founder" />
                     </FounderImage>
                     <FounderText> 
                        <FounderSmallText>{PersonInfo?.data?.theNeed?.quote}</FounderSmallText>
                        <FounderDesignation>{PersonInfo?.data?.theNeed?.personName}</FounderDesignation>
                     </FounderText>
                  </FounderNeed>
               </NeedSection>
                 
                 <OpportunitySection>
                     <NeedTitle>{MESSAGE.theOpportunityTitle}</NeedTitle>
                     <AboutSmallText>{MESSAGE.theOpportunity}</AboutSmallText>
                 </OpportunitySection>

                 <OpportunitySection>
                     <NeedTitle>{MESSAGE.theOutcomeTitle}</NeedTitle>
                     <AboutSmallText>{MESSAGE.theOutcome}</AboutSmallText>
                 </OpportunitySection>
            </Container>
         </AboutSection>
    </>
      </>
    
    )
}; 
export default ElliottAdvocacy;